import React from 'react';
import PagesShow from './Pages';
import CharShow from './Characters';
export default function MainLayout({
    pageContent,
    imageSrc,
    imageAlt,
    centered,
    flat,
}) {
    return (
        <>
            {
                !flat ? <PagesShow
                    imageSrc={imageSrc}
                    imageAlt={imageAlt}
                    leftChildren={pageContent}
                    centered={centered}
                /> : <CharShow
                    pageContent={pageContent}
                    flat={flat}
                />
            }
        </>
    );
}